import { useMemo } from "react";
import { Provider } from "react-redux";
import PhoneSystem from "./PhoneSystem";

export default () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <PhoneSystem />
    </Provider>
  );
};
